export const ADD_METADATA = "ADD_METADATA";
export const SET_METADATA = "SET_METADATA";
export const SET_PRODUCT_INFO = "SET_PRODUCT_INFO";
